import { useState } from "react";

export type AggregationFunction = "avg" | "min" | "max" | "median" | "count" | "sum";

export type AggregationsState = {
    setAggregations: (aggregations: AggregationFunction[] | undefined) => void;
};

type AggregationsParams = {
    query: AggregationFunction[] | undefined;
    state: AggregationsState;
};
export const useAggregations = (initAggregations?: AggregationFunction[]): AggregationsParams => {
    const [aggregations, setAggregations] = useState<AggregationFunction[] | undefined>(initAggregations);

    return {
        query: aggregations,
        state: {
            setAggregations,
        },
    };
};
